export const useIsTouch = (): boolean => {
  return typeof window !== 'undefined' && 'ontouchstart' in window;
};
